import NavLayout from "./NavLayout";

export default NavLayout;
